// Single source of truth for the bundled bell sound files (served from
// public/bells). Add or remove a file here and every player/scheduler that
// maps a stored bell to a local sound stays in sync.
export const BELL_SOUND_FILES = [
    "bell.mp3",
    "electric-bell.mp3",
    "emergency.mp3",
    "fire.mp3",
    "japanese-bell.mp3",
    "national-anthem.mp3",
    "public-song.mp3",
    "lunch-greeting.mp3",
];

// Map a stored bell uri/filename to its bundled sound in /public/bells, or null
// when there is no matching local file.
export const getLocalBellSound = (uri = "") => {
    const normalizedUri = String(uri).trim().split("?")[0].split("#")[0].replace(/\\/g, "/");
    const fileName = normalizedUri.split("/").filter(Boolean).pop()?.toLowerCase();
    const matchedFile = BELL_SOUND_FILES.find((file) => file.toLowerCase() === fileName);

    return matchedFile ? `/bells/${matchedFile}` : null;
};

// Ordered playback candidates for a bell, matching the scheduler's priority:
//   1. the backend (R2) URL from the API response,
//   2. the bundled /public/bells sound, only as a fallback.
// Accepts a raw url/path string.
export const resolveBellSources = (uri = "") => {
    const raw = String(uri ?? "").trim();
    const remote = /^https?:\/\//i.test(raw) ? raw : null;
    const local = getLocalBellSound(raw);

    const sources = [];
    if (remote) sources.push(remote);
    if (local && local !== remote) sources.push(local);
    // Last resort: a non-http path that isn't a known bundled file (kept for
    // backward compatibility with legacy stored values).
    if (sources.length === 0 && raw) sources.push(raw);

    return sources;
};
